import { MaterialConfig } from "fe-shared/src/types/domain";
import { CorrectionMaterial } from "../../../types";

import styles from "../EditTransferDialog.module.scss";

export const getCheckboxGroupProps = (tires: MaterialConfig[] = []) => ({
  name: "transfer-material-types-checkbox-group",
  width: "100%",
  variants: tires.map(({ code, name }) => ({
    id: code,
    title: name,
    value: code,
  })),
});

export const getMaterialsCountConfig = (
  materialsByCode: {
    [key: string]: MaterialConfig;
  },
  materialsConfig: CorrectionMaterial[] = [],
  isWithWeight = false
) =>
  materialsConfig.map(({ materialCode }, index) => ({
    valueKey: `materials[${index}].units.unitQuantity`,
    componentProps: {
      width: "102px",
      title: materialsByCode[materialCode]?.name,
      wrapperClassName: styles.tiresCountInput,
      mask: isWithWeight ? "999999999999" : "99999",
    },
  }));
